import React from 'react';
import { Inbox } from 'lucide-react';
import { Button } from '../ui/button';

export const EmptyState = ({ icon: Icon = Inbox, title, description, actionLabel, onAction }) => {
  return (
    <div className="flex flex-col items-center justify-center py-16 px-6 text-center" data-testid="empty-state">
      <div className="w-16 h-16 rounded-full bg-slate-100 flex items-center justify-center mb-4">
        <Icon className="w-8 h-8 text-slate-400" />
      </div>
      <h3 className="text-base font-semibold text-slate-900 mb-1 font-heading">{title}</h3>
      {description && <p className="text-sm text-slate-500 max-w-sm mb-5">{description}</p>}
      {actionLabel && (
        <Button onClick={onAction} className="bg-[#2E6DA4] hover:bg-[#255a88] text-white" data-testid="empty-state-action">
          {actionLabel}
        </Button>
      )}
    </div>
  );
};
